export { default } from 'features/partners-walmart/routes/walmart-plus-route';
